<script>
  import centralMensagensServico from '../servico';
  import iconeModulo from '../icones';
  import desktopEmbed from '~js/desktop-embed';
  import sessaoAvisos from '../sessao-avisos';
  import moment from 'moment';

  const INTERVALO = 60000;
  const OPCOES_ATENCAO = [
    { minutos: 0, texto: 'Só quando chegar algo novo' },
    { minutos: 15, texto: 'A cada 15 min' },
    { minutos: 30, texto: 'A cada 30 min' },
    { minutos: 60, texto: 'A cada 1 hora' },
  ];
  const CHAVE_RECOLHIDAS = 'avisos-secoes-recolhidas';

  function lerRecolhidas() {
    try {
      return JSON.parse(localStorage.getItem(CHAVE_RECOLHIDAS) || '{}') || {};
    } catch (e) {
      return {};
    }
  }

  const PREFIXO_LIBERAR_VISTO = 'avisos-liberar-visto-';

  function quantidadesLiberar(avisos) {
    const atual = {};
    (avisos.liberar || []).forEach(l => { atual['l' + l.idSol] = l.quantidade; });
    (avisos.filas || []).forEach(f => { atual['f' + f.chave] = f.quantidade; });
    return atual;
  }

  function lerLiberarVisto(idUsuario) {
    try {
      return JSON.parse(localStorage.getItem(PREFIXO_LIBERAR_VISTO + idUsuario) || 'null');
    } catch (e) {
      return null;
    }
  }

  function gravarLiberarVisto(idUsuario, quantidades) {
    try { localStorage.setItem(PREFIXO_LIBERAR_VISTO + idUsuario, JSON.stringify(quantidades)); } catch (e) { }
  }

  function nomeCurto(nome) {
    return (nome || '').replace(/^Solicitação de /i, '');
  }

  export default {
    data() {
      return {
        avisos: null,
        novosLiberar: {},
        carregando: false,
        erro: '',
        temporizador: null,
        recolhidas: lerRecolhidas(),
        configurando: false,
        catalogo: null,
        marcadas: [],
        salvando: false,
        carregandoCatalogo: false,
        intervaloAtencao: 0,
        opcoesAtencao: OPCOES_ATENCAO,
        abaConfig: 'mensagens',
        tiposAbertos: null,
        abasConfig: [
          { id: 'mensagens', nome: 'Mensagens', icone: 'fa-comments-o' },
          { id: 'liberacao', nome: 'Liberação', icone: 'fa-check-square-o' },
        ],
      };
    },
    computed: {
      grupos() {
        return (this.avisos && this.avisos.grupos) || [];
      },
      liberar() {
        return (this.avisos && this.avisos.liberar) || [];
      },
      filas() {
        return (this.avisos && this.avisos.filas) || [];
      },
      totalFilas() {
        return this.filas.reduce((soma, f) => soma + f.quantidade, 0);
      },
      paraVoce() {
        return (this.avisos && this.avisos.paraVoce) || [];
      },
      totalParaVoce() {
        return this.paraVoce.reduce((soma, p) => soma + p.quantidade, 0);
      },
      totalNovosLiberar() {
        return Object.keys(this.novosLiberar).reduce((soma, k) => soma + this.novosLiberar[k], 0);
      },
      totalNovos() {
        if (!this.avisos) return 0;
        return (this.avisos.novos || 0) + (this.avisos.novosParaVoce || 0) + this.totalNovosLiberar;
      },
      areasConfig() {
        return this.areasDaAba(this.abaConfig);
      },
      qtdAba() {
        const contar = aba => this.areasDaAba(aba).reduce((soma, a) => soma + a.itens.filter(i => this.marcada(i.chave)).length, 0);
        return { mensagens: contar('mensagens'), liberacao: contar('liberacao') };
      },
      atualizadoEm() {
        return this.avisos ? moment(this.avisos.atualizadoEm).format('HH:mm') : '';
      },
    },
    mounted() {
      window.managerAvisos = { abriu: () => this.abriu() };
      this.carregar();
      this.temporizador = setInterval(() => this.carregar(), INTERVALO);
    },
    beforeDestroy() {
      clearInterval(this.temporizador);
      if (window.managerAvisos) delete window.managerAvisos;
    },
    methods: {
      carregar() {
        if (this.carregando) return Promise.resolve();

        if (!sessaoAvisos.token) {
          desktopEmbed.enviar({ acao: 'sessaoExpirada' });
          return Promise.resolve();
        }

        this.carregando = true;

        return centralMensagensServico.avisos(sessaoAvisos.token)
          .then(dados => {
            this.avisos = dados;
            this.erro = '';
            this.calcularNovosLiberar();
            this.avisarDesktop();
          })
          .catch(resposta => {
            if (resposta && resposta.status === 401) {
              desktopEmbed.enviar({ acao: 'sessaoExpirada' });
              return;
            }
            this.erro = 'Não foi possível carregar os avisos agora.';
          })
          .finally(() => { this.carregando = false; });
      },
      calcularNovosLiberar() {
        const atual = quantidadesLiberar(this.avisos);
        const visto = lerLiberarVisto(this.avisos.idUsuario);

        if (!visto) {
          gravarLiberarVisto(this.avisos.idUsuario, atual);
          this.novosLiberar = {};
          return;
        }

        const novos = {};
        let ajustado = false;

        Object.keys(atual).forEach(k => {
          const anterior = visto[k] || 0;
          if (atual[k] > anterior) novos[k] = atual[k] - anterior;
          else if (atual[k] < anterior) { visto[k] = atual[k]; ajustado = true; }
        });

        Object.keys(visto).forEach(k => {
          if (!(k in atual)) { delete visto[k]; ajustado = true; }
        });

        if (ajustado) gravarLiberarVisto(this.avisos.idUsuario, visto);
        this.novosLiberar = novos;
      },
      detalheNovos() {
        const partes = [];
        const plural = (n, um, varios) => n + ' ' + (n === 1 ? um : varios);

        if (this.avisos.novosParaVoce) partes.push(plural(this.avisos.novosParaVoce, 'para você', 'para você'));
        if (this.avisos.novos) partes.push(plural(this.avisos.novos, 'conversa', 'conversas'));
        if (this.totalNovosLiberar) partes.push(plural(this.totalNovosLiberar, 'a liberar', 'a liberar'));
        return partes.join(' · ');
      },
      avisarDesktop() {
        const ultimo = this.avisos.ultimo;
        let texto = '';

        if (ultimo) {
          const trecho = (ultimo.ultimoTrecho || '').split('[Anexo] ').join('Anexo: ').replace(/\s+/g, ' ').trim();
          texto = (ultimo.ultimoUsuario || ultimo.descricao || '') + ' · ' + nomeCurto(ultimo.descricaoModulo)
            + ' ' + ultimo.numero + ': "' + trecho + '"';
        }

        desktopEmbed.enviar({ acao: 'avisos', total: this.avisos.total, novos: this.totalNovos, detalhe: this.detalheNovos(), liberar: this.avisos.totalLiberar + this.totalFilas, paraVoce: this.totalParaVoce, atencao: this.avisos.intervaloAtencao || 0, texto });
      },
      abriu() {
        if (this.avisos) {
          gravarLiberarVisto(this.avisos.idUsuario, quantidadesLiberar(this.avisos));
          this.novosLiberar = {};
        }

        return centralMensagensServico.avisosVisto(sessaoAvisos.token)
          .then(() => this.carregar())
          .catch(() => {});
      },
      abrirCentral(modulo) {
        desktopEmbed.enviar({ acao: 'abrirCentral', modulo: modulo || 0, numero: 0 });
      },
      alternar(secao) {
        this.recolhidas = Object.assign({}, this.recolhidas, { [secao]: !this.recolhidas[secao] });
        try { localStorage.setItem(CHAVE_RECOLHIDAS, JSON.stringify(this.recolhidas)); } catch (e) { }
      },
      abrirConversa(p) {
        desktopEmbed.enviar({ acao: 'abrirConversa', modulo: p.modulo, numero: p.numero });
      },
      quando(data) {
        const d = moment(data);
        return d.isSame(moment(), 'day') ? d.format('HH:mm') : d.format('DD/MM HH:mm');
      },
      abrirSolicitacoes(idSol) {
        desktopEmbed.enviar({ acao: 'abrirSolicitacoes', idSol });
      },
      icone(modulo) {
        return iconeModulo(modulo);
      },
      abrirFila(fila) {
        desktopEmbed.enviar({ acao: 'abrirFila', fila: fila.chave });
      },
      abrirConfiguracao() {
        if (this.carregandoCatalogo) return;

        this.carregandoCatalogo = true;
        centralMensagensServico.meusAvisos(sessaoAvisos.token)
          .then(catalogo => {
            this.catalogo = catalogo;
            this.marcadas = (catalogo.marcadas || []).filter(c => c.indexOf('atencao:') !== 0);
            this.intervaloAtencao = catalogo.intervaloAtencao || 0;
            this.abaConfig = 'mensagens';
            this.tiposAbertos = null;
            this.configurando = true;
          })
          .catch(() => toastr.error('Não foi possível carregar as opções de avisos.'))
          .finally(() => { this.carregandoCatalogo = false; });
      },
      fecharConfiguracao() {
        if (this.salvando) return;
        this.configurando = false;
      },
      marcada(chave) {
        return this.marcadas.indexOf(chave) >= 0;
      },
      definir(chave, ligada) {
        const sem = this.marcadas.filter(c => c !== chave);
        this.marcadas = ligada ? sem.concat(chave) : sem;
      },
      areasDaAba(aba) {
        if (!this.catalogo) return [];

        const liberacao = aba === 'liberacao';

        return this.catalogo.areas
          .map(area => {
            const vistas = {};
            const itens = area.itens
              .filter(i => {
                const chave = liberacao ? i.chaveLiberar : i.chave;
                if (!chave || vistas[chave]) return false;
                vistas[chave] = true;
                return true;
              })
              .map(i => ({
                chave: liberacao ? i.chaveLiberar : i.chave,
                nome: area.chave === 'solicitacoes' ? nomeCurto(liberacao ? (i.nomeLiberar || i.nome) : i.nome) : (liberacao ? (i.nomeLiberar || i.nome) : i.nome),
                dica: liberacao ? i.dicaLiberar : i.dica,
                subtipos: (liberacao ? i.subtiposLiberar : i.subtipos) || [],
                tipos: (liberacao ? i.tiposCompraLiberar : i.tiposCompra) || [],
              }));

            if (area.chave === 'solicitacoes')
              itens.sort((a, b) => a.nome.localeCompare(b.nome, 'pt-BR'));

            return { chave: area.chave, nome: area.nome, itens };
          })
          .filter(a => a.itens.length);
      },
      resumoTipos(item) {
        const qtd = item.tipos.filter(t => this.marcada(t.chave)).length;
        return qtd === 0 ? 'todos' : qtd + (qtd === 1 ? ' selecionado' : ' selecionados');
      },
      alternarTipos(item) {
        this.tiposAbertos = this.tiposAbertos === item.chave ? null : item.chave;
      },
      alternarItem(item) {
        const ligar = !this.marcada(item.chave);
        this.definir(item.chave, ligar);
        item.subtipos.forEach(t => this.definir(t.chave, ligar));
      },
      alternarSubtipo(item, subtipo) {
        this.definir(subtipo.chave, !this.marcada(subtipo.chave));
        this.definir(item.chave, item.subtipos.some(t => this.marcada(t.chave)));
      },
      todosMarcados(area) {
        return area.itens.every(i => this.marcada(i.chave));
      },
      alternarTodos(area) {
        const ligar = !this.todosMarcados(area);
        area.itens.forEach(i => {
          this.definir(i.chave, ligar);
          i.subtipos.forEach(t => this.definir(t.chave, ligar));
        });
      },
      salvarConfiguracao() {
        if (this.salvando) return;

        this.salvando = true;
        const chaves = this.intervaloAtencao > 0 ? this.marcadas.concat('atencao:' + this.intervaloAtencao) : this.marcadas;
        centralMensagensServico.salvarMeusAvisos(sessaoAvisos.token, chaves)
          .then(() => {
            this.configurando = false;
            toastr.success('Avisos atualizados.');
            return this.carregar();
          })
          .catch(() => toastr.error('Não foi possível salvar os avisos.'))
          .finally(() => { this.salvando = false; });
      },
    },
  }
</script>

<template>
  <div class="av-raiz">
    <div class="av-topo">
      <div class="av-sino"><i class="fa fa-bell-o"></i></div>
      <div class="av-titulo">
        <strong>Avisos</strong>
        <span v-if="avisos && avisos.configurado === false">Ainda sem configuração</span>
        <span v-else-if="avisos">Atualizado às {{ atualizadoEm }} · mensagens dos últimos 90 dias
          <b v-if="erro" class="av-falha" :title="erro"><i class="fa fa-exclamation-triangle"></i> sem conexão</b>
        </span>
        <span v-else>Carregando…</span>
      </div>
      <button v-if="!configurando" type="button" class="av-icone" title="Meus avisos: escolher o que aparece aqui" aria-label="Meus avisos"
              :disabled="carregandoCatalogo" @click="abrirConfiguracao">
        <i :class="['fa', carregandoCatalogo ? 'fa-spinner fa-pulse' : 'fa-cog']"></i>
      </button>
      <button v-if="!configurando" type="button" class="av-icone" title="Atualizar" aria-label="Atualizar" :disabled="carregando" @click="carregar">
        <i :class="['fa', 'fa-refresh', { 'fa-spin': carregando }]"></i>
      </button>
    </div>

    <template v-if="configurando && catalogo">
      <div class="av-config-cabeca">
        <div class="av-config-intro">
          <strong>Meus avisos</strong>
          <span>Escolha o que aparece no seu painel. Só aparecem as opções que a fundação usa.</span>
        </div>
        <div class="av-config-abas" role="tablist">
          <button v-for="aba in abasConfig" :key="aba.id" type="button" role="tab" :aria-selected="abaConfig === aba.id ? 'true' : 'false'"
                  :class="['av-config-aba', 'av-config-aba-' + aba.id, { ativa: abaConfig === aba.id }]" @click="abaConfig = aba.id">
            <i :class="['fa', aba.icone]"></i>
            <span>{{ aba.nome }}</span>
            <span class="av-config-aba-qtd">{{ qtdAba[aba.id] }}</span>
          </button>
        </div>
      </div>

      <div class="av-corpo">
        <div :class="['av-config-faixa', 'av-config-faixa-' + abaConfig]">
          <i :class="['fa', abaConfig === 'mensagens' ? 'fa-comments-o' : 'fa-check-square-o']"></i>
          <span v-if="abaConfig === 'mensagens'">Conversas novas nas solicitações. Você vê a mensagem e responde pela Central.</span>
          <span v-else>O que está esperando a fundação agir. O clique abre a tela do Manager já filtrada.</span>
        </div>

        <div v-if="!areasConfig.length" class="av-cartao av-secao-vazia">Nada disponível nesta aba.</div>

        <section v-for="area in areasConfig" :key="abaConfig + area.chave" class="av-cartao">
          <div class="av-config-area">
            <strong>{{ area.nome }}</strong>
            <button type="button" class="av-config-link" @click="alternarTodos(area)">{{ todosMarcados(area) ? 'Desmarcar todos' : 'Marcar todos' }}</button>
          </div>

          <div v-for="item in area.itens" :key="item.chave" class="av-config-item">
            <label class="av-config-linha">
              <input type="checkbox" :checked="marcada(item.chave)" @change="alternarItem(item)">
              <span class="av-config-texto">
                <span>{{ item.nome }}</span>
                <small v-if="item.dica">{{ item.dica }}</small>
              </span>
            </label>
            <div v-if="item.subtipos.length && marcada(item.chave)" class="av-config-subtipos">
              <button v-for="t in item.subtipos" :key="t.chave" type="button" :aria-pressed="marcada(t.chave) ? 'true' : 'false'"
                      :class="['av-chip', { ligado: marcada(t.chave) }]" @click="alternarSubtipo(item, t)">
                {{ t.nome }}
              </button>
            </div>
            <div v-if="item.tipos.length && marcada(item.chave)" class="av-config-tipos">
              <div class="av-config-tipos-linha">
                <span>Tipos de compra: <strong>{{ resumoTipos(item) }}</strong></span>
                <button type="button" class="av-config-link" @click="alternarTipos(item)">{{ tiposAbertos === item.chave ? 'Fechar' : 'Escolher' }}</button>
              </div>
              <div v-if="tiposAbertos === item.chave" class="av-config-subtipos av-config-subtipos-tipos">
                <button v-for="t in item.tipos" :key="t.chave" type="button" :aria-pressed="marcada(t.chave) ? 'true' : 'false'"
                        :class="['av-chip', { ligado: marcada(t.chave) }]" @click="definir(t.chave, !marcada(t.chave))">
                  {{ t.nome }}
                </button>
              </div>
            </div>
          </div>
        </section>

        <section class="av-cartao av-config-lembrete">
          <label for="av-lembrete" class="av-config-texto">
            <span>Lembrete</span>
            <small>Volta a piscar enquanto houver pendência</small>
          </label>
          <select id="av-lembrete" v-model.number="intervaloAtencao" class="av-config-select">
            <option v-for="o in opcoesAtencao" :key="o.minutos" :value="o.minutos">{{ o.texto }}</option>
          </select>
        </section>
      </div>

      <div class="av-config-rodape">
        <button type="button" class="btn btn-primary av-btn" :disabled="salvando" @click="salvarConfiguracao">
          <i :class="['fa', salvando ? 'fa-spinner fa-pulse' : 'fa-check']"></i> Salvar
        </button>
        <button type="button" class="btn btn-white av-btn" :disabled="salvando" @click="fecharConfiguracao">
          <i class="fa fa-arrow-left"></i> Voltar
        </button>
      </div>
    </template>

    <div v-else class="av-corpo">
      <div v-if="erro && !avisos" class="av-vazio">
        <i class="fa fa-exclamation-triangle"></i>
        <p>{{ erro }}</p>
      </div>

      <section v-else-if="avisos && avisos.configurado === false" class="av-cartao av-convite">
        <div class="av-convite-icone"><i class="fa fa-cog"></i></div>
        <strong>Escolha o que aparece aqui</strong>
        <p>Você ainda não configurou seus avisos. Marque as mensagens e as liberações que quer acompanhar e o painel passa a mostrar só isso.</p>
        <button type="button" class="btn btn-primary av-btn" :disabled="carregandoCatalogo" @click="abrirConfiguracao">
          <i :class="['fa', carregandoCatalogo ? 'fa-spinner fa-pulse' : 'fa-cog']"></i> Configurar meus avisos
        </button>
      </section>

      <template v-else-if="avisos">
        <section class="av-cartao av-cartao-msg">
          <button type="button" class="av-cartao-topo" :aria-expanded="recolhidas.mensagens ? 'false' : 'true'" @click="alternar('mensagens')">
            <span class="av-cartao-icone"><i class="fa fa-comments-o"></i></span>
            <span class="av-cartao-nome">Mensagens não lidas</span>
            <span v-if="avisos.novos > 0" class="av-novos">{{ avisos.novos }} {{ avisos.novos === 1 ? 'novo' : 'novos' }}</span>
            <span class="av-cartao-qtd">{{ avisos.total }}</span>
            <i :class="['fa', recolhidas.mensagens ? 'fa-angle-down' : 'fa-angle-up', 'av-cartao-seta']"></i>
          </button>

          <div v-show="!recolhidas.mensagens">
            <template v-if="paraVoce.length">
              <button type="button" class="av-sub av-sub-paravoce" :aria-expanded="recolhidas.paraVoce ? 'false' : 'true'" @click="alternar('paraVoce')">
                <i :class="['fa', recolhidas.paraVoce ? 'fa-angle-right' : 'fa-angle-down', 'av-sub-seta']"></i>
                <span class="av-sub-nome"><i class="fa fa-user"></i> Para você</span>
                <span v-if="avisos.novosParaVoce > 0" class="av-tag-novo">{{ avisos.novosParaVoce }} {{ avisos.novosParaVoce === 1 ? 'nova' : 'novas' }}</span>
                <span class="av-sub-qtd">{{ totalParaVoce }}</span>
              </button>

              <button v-for="p in paraVoce" v-show="!recolhidas.paraVoce" :key="'p' + p.modulo + '-' + p.numero" type="button" class="av-pv"
                      :title="'Abrir a conversa da ' + p.nome + ' nº ' + p.numero" @click="abrirConversa(p)">
                <span class="av-pv-topo">
                  <i :class="icone(p.modulo).icone" :style="{ color: icone(p.modulo).cor }"></i>
                  <strong>{{ p.nome }} {{ p.numero }}</strong>
                  <span class="av-pv-quando">{{ quando(p.ultimaData) }}</span>
                </span>
                <span class="av-pv-texto"><b>{{ p.remetente }}:</b> {{ p.trecho }}</span>
              </button>

              <div v-if="grupos.length" class="av-sub av-sub-fixo">
                <span class="av-sub-nome">Por módulo</span>
              </div>
            </template>

            <div v-if="!grupos.length" class="av-secao-vazia">
              <i class="fa fa-check-circle-o"></i> Nenhuma mensagem não lida nos seus módulos.
            </div>

            <button v-for="g in grupos" :key="'m' + g.modulo" type="button" :class="['av-grupo', { 'av-grupo-novo': g.novos > 0 }]"
                    :title="'Abrir ' + g.nome + ' na Central de Mensagens'" @click="abrirCentral(g.modulo)">
              <i :class="icone(g.modulo).icone" :style="{ color: icone(g.modulo).cor }"></i>
              <span class="av-grupo-nome">{{ g.nome }}</span>
              <span v-if="g.novos > 0 && g.novos < g.quantidade" class="av-tag-novo">{{ g.novos }} {{ g.novos === 1 ? 'novo' : 'novos' }}</span>
              <span class="av-qtd">{{ g.quantidade }}</span>
              <i class="fa fa-angle-right av-seta"></i>
            </button>
          </div>

          <button type="button" class="av-cartao-acao" @click="abrirCentral()">
            <i class="fa fa-comments-o"></i> Abrir Central de Mensagens
          </button>
        </section>

        <section v-if="filas.length" class="av-cartao av-cartao-filas">
          <button type="button" class="av-cartao-topo" :aria-expanded="recolhidas.filas ? 'false' : 'true'" @click="alternar('filas')">
            <span class="av-cartao-icone"><i class="fa fa-tasks"></i></span>
            <span class="av-cartao-nome">Compras e importação</span>
            <span class="av-cartao-qtd">{{ totalFilas }}</span>
            <i :class="['fa', recolhidas.filas ? 'fa-angle-down' : 'fa-angle-up', 'av-cartao-seta']"></i>
          </button>

          <div v-show="!recolhidas.filas">
            <button v-for="f in filas" :key="f.chave" type="button" class="av-grupo av-grupo-fila"
                    :title="'Abrir ' + f.nome.toLowerCase() + ' no Manager'" @click="abrirFila(f)">
              <i :class="icone(f.modulo).icone" :style="{ color: icone(f.modulo).cor }"></i>
              <span class="av-grupo-nome">{{ f.nome }}</span>
              <span v-if="novosLiberar['f' + f.chave]" class="av-tag-novo">{{ novosLiberar['f' + f.chave] }} {{ novosLiberar['f' + f.chave] === 1 ? 'nova' : 'novas' }}</span>
              <span class="av-qtd av-qtd-fila">{{ f.quantidade }}</span>
              <i class="fa fa-angle-right av-seta"></i>
            </button>
          </div>
        </section>

        <section class="av-cartao av-cartao-liberar">
          <button type="button" class="av-cartao-topo" :aria-expanded="recolhidas.liberar ? 'false' : 'true'" @click="alternar('liberar')">
            <span class="av-cartao-icone"><i class="fa fa-check-square-o"></i></span>
            <span class="av-cartao-nome">Solicitações a liberar</span>
            <span v-if="totalNovosLiberar > 0" class="av-novos">{{ totalNovosLiberar }} {{ totalNovosLiberar === 1 ? 'nova' : 'novas' }}</span>
            <span class="av-cartao-qtd">{{ avisos.totalLiberar }}</span>
            <i :class="['fa', recolhidas.liberar ? 'fa-angle-down' : 'fa-angle-up', 'av-cartao-seta']"></i>
          </button>

          <div v-show="!recolhidas.liberar">
            <div v-if="!liberar.length" class="av-secao-vazia">
              <i class="fa fa-check-circle-o"></i> Nenhuma solicitação aguardando liberação nos seus módulos.
            </div>

            <button v-for="l in liberar" :key="'l' + l.idSol" type="button" class="av-grupo av-grupo-liberar"
                    :title="'Abrir ' + l.nome + ' com as pendentes de liberação'" @click="abrirSolicitacoes(l.idSol)">
              <i :class="icone(l.modulo).icone" :style="{ color: icone(l.modulo).cor }"></i>
              <span class="av-grupo-nome">{{ l.nome }}</span>
              <span v-if="novosLiberar['l' + l.idSol]" class="av-tag-novo">{{ novosLiberar['l' + l.idSol] }} {{ novosLiberar['l' + l.idSol] === 1 ? 'nova' : 'novas' }}</span>
              <span class="av-qtd av-qtd-liberar">{{ l.quantidade }}</span>
              <i class="fa fa-angle-right av-seta"></i>
            </button>

            <div v-if="liberar.length" class="av-cartao-nota">Abre a tela do Manager já filtrada nas pendentes.</div>
          </div>
        </section>
      </template>
    </div>
  </div>
</template>

<style scoped>
  .av-raiz { height: 100vh; box-sizing: border-box; display: flex; flex-direction: column; background: #fff; color: #1c2024; font-size: 13px; }
  .av-topo { padding: 14px 16px 12px; display: flex; align-items: center; gap: 10px; border-bottom: 1px solid #eef0f3; }
  .av-sino { width: 34px; height: 34px; border-radius: 8px; background: #e3f4ee; color: #0a6d4d; display: flex; align-items: center; justify-content: center; font-size: 17px; flex: 0 0 auto; }
  .av-titulo { flex: 1 1 auto; min-width: 0; display: flex; flex-direction: column; }
  .av-titulo strong { font-size: 16px; font-weight: 600; }
  .av-titulo span { font-size: 12px; color: #5b6570; }
  .av-icone { width: 34px; height: 34px; border: 1px solid #e7eaec; border-radius: 3px; background: #fff; color: #3b444d; cursor: pointer; }
  .av-icone:disabled { cursor: default; color: #8a939c; }
  .av-novos { background: #a13c3c; color: #fff; border-radius: 999px; padding: 1px 8px; font-weight: 600; font-size: 11px; white-space: nowrap; }
  .av-falha { color: #9a5b00; font-size: 11px; white-space: nowrap; font-weight: 600; }
  .av-corpo { flex: 1 1 auto; overflow-y: auto; min-height: 0; background: #f3f5f7; padding: 10px 10px 14px; display: flex; flex-direction: column; gap: 12px; }
  .av-convite { padding: 24px 20px; text-align: center; display: flex; flex-direction: column; align-items: center; gap: 8px; }
  .av-convite-icone { width: 44px; height: 44px; border-radius: 50%; background: #e3f4ee; color: #0a6d4d; display: flex; align-items: center; justify-content: center; font-size: 20px; }
  .av-convite strong { font-size: 14px; }
  .av-convite p { margin: 0 0 6px; color: #5b6570; line-height: 1.45; }
  .av-vazio { padding: 40px 24px; text-align: center; color: #5b6570; }
  .av-vazio i { font-size: 30px; color: #1ab394; }
  .av-vazio p { margin: 10px 0 0; }
  .av-cartao { flex: 0 0 auto; background: #fff; border: 1px solid #e1e5ea; border-radius: 8px; overflow: hidden; box-shadow: 0 1px 2px rgba(16, 24, 40, 0.04); }
  .av-cartao-topo { width: 100%; border: none; border-bottom: 1px solid #eef0f3; background: #fff; padding: 10px 12px; display: flex; align-items: center; gap: 9px; cursor: pointer; text-align: left; color: #1c2024; }
  .av-cartao-topo:hover { background: #fafbfc; }
  .av-cartao-icone { width: 28px; height: 28px; border-radius: 7px; display: inline-flex; align-items: center; justify-content: center; font-size: 14px; flex: 0 0 auto; }
  .av-cartao-msg .av-cartao-icone { background: #e3f4ee; color: #0a6d4d; }
  .av-cartao-liberar .av-cartao-icone { background: #fdf0dc; color: #b06a07; }
  .av-cartao-nome { flex: 1 1 auto; font-size: 13.5px; font-weight: 700; }
  .av-cartao-qtd { font-weight: 700; font-size: 13px; color: #1c2024; }
  .av-cartao-seta { color: #8a939c; width: 12px; text-align: center; }
  .av-cartao-acao { width: 100%; border: none; border-top: 1px solid #e3efe9; background: #f1f9f5; color: #0a6d4d; font-weight: 600; font-size: 13px; padding: 10px 12px; cursor: pointer; }
  .av-cartao-acao:hover { background: #e3f4ee; }
  .av-cartao-acao i { margin-right: 4px; }
  .av-cartao-nota { padding: 8px 12px; font-size: 11.5px; color: #6b7580; background: #fcfcfd; }
  .av-sub { width: 100%; border: none; border-bottom: 1px solid #eef0f3; padding: 6px 12px; display: flex; gap: 8px; align-items: center; font-size: 10.5px; font-weight: 700; letter-spacing: .05em; text-transform: uppercase; color: #6b7580; background: #f8f9fb; text-align: left; }
  button.av-sub { cursor: pointer; }
  .av-sub-nome { flex: 1 1 auto; }
  .av-sub-seta { width: 10px; font-size: 12px; }
  .av-sub-qtd { font-weight: 700; }
  .av-sub-paravoce, .av-sub-paravoce:hover { background: #1f4f82; color: #fff; }
  .av-secao-vazia { padding: 12px 14px; font-size: 12px; color: #5b6570; border-bottom: 1px solid #eef0f3; }
  .av-secao-vazia i { color: #1ab394; margin-right: 4px; }
  .av-grupo { width: 100%; border: none; border-bottom: 1px solid #f0f2f4; border-left: 3px solid transparent; background: #fff; cursor: pointer; display: flex; align-items: center; gap: 10px; padding: 10px 12px 10px 11px; min-height: 42px; text-align: left; color: inherit; }
  .av-grupo:last-child { border-bottom: none; }
  .av-grupo:hover { background: #f4f8f6; }
  .av-grupo-liberar:hover { background: #fdf8f0; }
  .av-grupo-novo { border-left-color: #a13c3c; }
  .av-grupo-novo .av-grupo-nome { font-weight: 700; }
  .av-grupo-nome { flex: 1 1 auto; font-size: 13px; font-weight: 600; }
  .av-tag-novo { color: #a13c3c; font-size: 11px; font-weight: 700; white-space: nowrap; }
  .av-sub-paravoce .av-tag-novo { background: #a13c3c; color: #fff; border-radius: 999px; padding: 1px 8px; }
  .av-qtd { background: #6b7580; color: #fff; border-radius: 999px; font-size: 11px; font-weight: 600; min-width: 22px; height: 20px; padding: 0 7px; display: inline-flex; align-items: center; justify-content: center; }
  .av-grupo-novo .av-qtd { background: #a13c3c; }
  .av-qtd-liberar { background: #d9820b; }
  .av-pv { width: 100%; border: none; border-bottom: 1px solid #eef0f3; border-left: 3px solid #1f4f82; background: #f2f6fb; cursor: pointer;
           display: flex; flex-direction: column; gap: 3px; padding: 9px 12px 9px 11px; text-align: left; color: inherit; }
  .av-pv:hover { background: #e6eef8; }
  .av-pv-topo { display: flex; align-items: center; gap: 8px; }
  .av-pv-topo strong { flex: 1 1 auto; font-size: 13px; min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
  .av-pv-quando { font-size: 11px; color: #5b6570; white-space: nowrap; }
  .av-pv-texto { font-size: 12px; color: #3d464f; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
  .av-seta { color: #8a939c; font-size: 16px; }
  .av-topo .av-icone + .av-icone { margin-left: -4px; }
  .av-cartao-filas .av-cartao-icone { background: #e8eef7; color: #1f4f82; }
  .av-grupo-fila:hover { background: #f2f6fb; }
  .av-qtd-fila { background: #1f4f82; }
  .av-config-cabeca { flex: 0 0 auto; background: #fff; border-bottom: 1px solid #e1e5ea; padding: 10px 12px 0; display: flex; flex-direction: column; gap: 8px; }
  .av-config-intro { display: flex; flex-direction: column; gap: 2px; }
  .av-config-intro strong { font-size: 14px; }
  .av-config-intro span { font-size: 12px; color: #5b6570; }
  .av-config-abas { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); }
  .av-config-aba { height: 40px; border: none; border-bottom: 3px solid transparent; background: none; display: flex; align-items: center; justify-content: center; gap: 7px; font-size: 13.5px; font-weight: 600; color: #5b6570; cursor: pointer; }
  .av-config-aba .fa { font-size: 15px; color: #8a939c; }
  .av-config-aba-qtd { min-width: 22px; height: 19px; padding: 0 6px; box-sizing: border-box; border-radius: 10px; font-size: 11px; font-weight: 700; display: inline-flex; align-items: center; justify-content: center; background: #e3e6ea; color: #3a434c; }
  .av-config-aba.ativa { color: #0a5c4a; border-bottom-color: #13a183; }
  .av-config-aba.ativa .av-config-aba-qtd { background: #13a183; color: #fff; }
  .av-config-aba-mensagens.ativa .fa { color: #2563a8; }
  .av-config-aba-liberacao.ativa .fa { color: #9a5208; }
  .av-config-faixa { display: flex; align-items: center; gap: 10px; padding: 9px 12px; border-radius: 8px; font-size: 12.5px; line-height: 1.4; color: #3a434c; }
  .av-config-faixa .fa { font-size: 17px; flex: 0 0 auto; }
  .av-config-faixa-mensagens { background: #e8f0fa; border: 1px solid #c9dbf1; }
  .av-config-faixa-mensagens .fa { color: #2563a8; }
  .av-config-faixa-liberacao { background: #fdf1e2; border: 1px solid #f3d8b5; }
  .av-config-faixa-liberacao .fa { color: #9a5208; }
  .av-config-area { padding: 8px 12px; border-bottom: 1px solid #eef0f3; display: flex; align-items: center; justify-content: space-between; gap: 8px; }
  .av-config-area strong { font-size: 13.5px; }
  .av-config-link { border: none; background: none; padding: 4px 0; font-size: 12.5px; font-weight: 600; color: #0f7a63; cursor: pointer; }
  .av-config-link:hover { color: #0a5c4a; text-decoration: underline; }
  .av-config-item { border-bottom: 1px solid #f0f2f4; }
  .av-config-item:last-child { border-bottom: none; }
  .av-config-linha { display: flex; align-items: flex-start; gap: 10px; padding: 9px 12px; margin: 0; font-weight: normal; cursor: pointer; }
  .av-config-linha:hover { background: #fafbfc; }
  .av-config-linha input { margin: 2px 0 0; width: 15px; height: 15px; flex: 0 0 auto; cursor: pointer; }
  .av-config-texto { display: flex; flex-direction: column; min-width: 0; flex: 1 1 auto; margin: 0; font-weight: normal; }
  .av-config-texto span { font-size: 13px; font-weight: 600; color: #26313b; }
  .av-config-texto small { font-size: 11.5px; color: #5b6570; }
  .av-config-subtipos { display: flex; flex-wrap: wrap; gap: 6px; padding: 0 12px 10px 37px; }
  .av-config-tipos { margin: 0 12px 10px 37px; border: 1px solid #eef0f3; border-radius: 6px; background: #fafbfc; padding: 6px 10px; display: flex; flex-direction: column; gap: 8px; }
  .av-config-tipos-linha { display: flex; align-items: center; justify-content: space-between; gap: 8px; font-size: 12.5px; color: #3a434c; }
  .av-config-subtipos-tipos { padding: 0; }
  .av-config-lembrete { display: flex; align-items: center; justify-content: space-between; gap: 10px; padding: 10px 12px; }
  .av-config-select { height: 30px; border: 1px solid #cfd4da; border-radius: 4px; padding: 0 6px; font-size: 12.5px; background: #fff; color: #26313b; }
  .av-chip { border: 1px solid #d5dbe2; background: #fff; color: #3a434c; border-radius: 999px; padding: 3px 10px; font-size: 12px; cursor: pointer; }
  .av-chip:hover { border-color: #b9c3cf; }
  .av-chip.ligado { background: #e3f4ee; border-color: #8fcfb6; color: #0a6d4d; font-weight: 600; }
  .av-config-rodape { padding: 10px 12px; border-top: 1px solid #eef0f3; display: flex; justify-content: flex-end; gap: 8px; background: #fff; }
  .av-btn { font-size: 13px; }
</style>



// WEBPACK FOOTER //
// FrontEnd/modulos/central-mensagens/componentes/AvisosMensagens.vue